/*=========================================================================================
  File Name: moduleAuthGetters.js
  Description: Auth Module Getters
  ----------------------------------------------------------------------------------------
  
==========================================================================================*/
import get from 'lodash.get'
const getters = {
    getAppActiveUser: (state) => {
        if (get(state, 'user.id')  && get(state, 'user.info.username'))
            return state.user
        return false
    }
}

export default getters



